module.exports = __webpack_public_path__ + "img/41fb973.jpg";